export default {
    name: 'users',
    serverName: 'api/v1/users/',
    apiUrl: '/api/v1/users/'
};
